<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
    </div>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      :table-col-check="{isShow:true,name:'PaymentAudit' + activeTab}" :key="activeTab" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination($event, page)" :isShowRowSelection="true">
      <template slot="operation" slot-scope="{text,record}">
        <el-button size="mini" type="primary" v-if="record.status === 'APPLYING' && !isAuditViewOnly"
          @click="handleEdit(record)">审核</el-button>
        <el-button size="mini" type="success" v-if="isAuditViewOnly"
          @click="handleDetails(record)">查看详情</el-button>
        <el-button size="mini" type="primary" color="#ffffff"
          v-if="record['annex']?.['CLAIM_THE_INVOICE_ANNEX'] && record.status!=='APPLYING'" icon="el-icon-download"
          @click="download(record)">下载附件</el-button>
      </template>
      <template slot="invoiceNumber" slot-scope="{record,text}" v-if="text">
        <el-link type="primary" v-if="record.status !== 'DEFEAT'" :underline="false" @click="openInvoice(text)"><i
            v-html="viewDetailIcon"></i>{{ text }}
        </el-link>
        <span v-else>{{text}}</span>
      </template>
      <template slot="contractNumbers" slot-scope="{record,text,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </template>
      <template slot="status" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </template>
      <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <tickets-details v-if="showInvoice" :show-dialog="showInvoice" :select-detail="InvoiceInfos"
      @submit="close"></tickets-details>
    <payment-audit-dialog v-if="showCheckDialog" :show-dialog="showCheckDialog" :select-detail="selectDetail"
      :readonly="isAuditViewOnly" @submit="closeCheckDialog"></payment-audit-dialog>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import { getAuditPage} from "@/api/dilivery/audit";
import {PaymentAudit} from "@/utils/data/tableCol/audit/Payment/PaymentAudit";
import {getTicketsPage} from "@/api/dilivery/tickets";
import TicketsDetails from "@/components/tickets/TicketsDetails.vue";
import PaymentAuditDialog from "@/components/audit/payment/PaymentAuditDialog.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import {viewDetailIcon} from "@/utils/icon";
import _ from "lodash";
import {getUserPage} from "@/api/dilivery/customer/user";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import {getStatusColor} from "../../../color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "PaymentCheck",
  components: {CustomerUserInfo, PictureLoading, PaymentAuditDialog, ExFoldTableCell,TicketsDetails, TableHeadNote},
  mixins: [tableOperationMixin, auditViewOnlyMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'ALL', showBadge: false },
        { label: '待审批', name: 'APPLYING', showBadge: true },
        { label: '已通过', name: 'SUCCESS', showBadge: false },
        { label: '已驳回', name: 'DEFEAT', showBadge: false },
      ],
      sendData: {
        ALL: { "query#status.IN": "APPLYING,SUCCESS,DEFEAT" },
        APPLYING: { "query#status.EQ": "APPLYING" },
        SUCCESS: { 'query#status.EQ': "SUCCESS" },
        DEFEAT: { "query#status.EQ": "DEFEAT" },
      },
      pageTotal: { ALL: 0, APPLYING: 0, SUCCESS: 0, DEFEAT: 0 },
      activeTab: 'APPLYING',
      loading: true,
      contactInfo: [],
      showContactInfo: false,
      showCheckDialog: false,
      selectDetail: '',
      showDetailsDialog: false,
      showDetails: '',
      InvoiceInfos: '',
      showInvoice: false,
      viewDetailIcon: viewDetailIcon
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(PaymentAudit([], this.activeTab)))
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    getStatusColor,
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    loadAllTabTotals() {
      // 销售侧角色（SALES_MANAGER、SALES）仅查看详情，不发起标签页红点数量查询
      if (this.isAuditViewOnly) return
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getAuditPage({ 'page.current': 1, 'page.size': 1 }, sendData, 'CLAIM_INVOICE_AUDIT').then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    showContact(contactName) {
      let data = {
        "query#contactName.IN": contactName.join(',')
      }
      getUserPage({}, data).then(res => {
        if (res.code === 200) {
          this.contactInfo = res.data.records
          this.showContactInfo = true
        } else {
          this.showContactInfo = false
        }
      }).catch(err => {
        this.showContactInfo = false
      })
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    openInvoice(invoiceNumber) {
      let data = {
        "query#invoiceNumber.EQ": invoiceNumber
      }
      getTicketsPage({}, data).then(res => {
        if (res.code === 200) {
          this.InvoiceInfos = res.data.records[0]
          this.showInvoice = true
        }
      }).catch(err => {
        this.showInvoice = false
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    async download(row) {
      try {
        let url = `${baseURL}/audit-info/attachment/${row.id}/CLAIM_THE_INVOICE_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getAuditPage(params, sendData, 'CLAIM_INVOICE_AUDIT').then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records.map(item => {
            return { ...item, dataRaw: JSON.parse(item.rawData) }
          })
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          // 销售侧角色不展示标签页红点数量
          if (!this.isAuditViewOnly) {
              this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
          }
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'status') {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        }
        if (['contractNumber','paymentAmount','invoiceTitle','receivingUnit','salesName'].includes(item.key)) {
          sendData[item.key] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    async handleEdit(row) {
      try {
        const res = await getAuditPage({}, { "query#id.EQ": row.id }, 'CLAIM_INVOICE_AUDIT')
        if (res.code === 200 && res.data.records.length > 0) {
          if (res.data.records[0].status !== 'APPLYING') {
            this.$messageUi.error('该到款已审核')
            this.getData(true)
            return
          }
          this.selectDetail = { ...res.data.records[0] }
        } else {
          this.$messageUi.error('到款数据获取失败')
          return
        }
        this.showCheckDialog = true
      } catch (error) {
        console.log(error);
        this.showCheckDialog = false
        this.$messageUi.error('打开审核页面失败')
      }
    },
    closeCheckDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showCheckDialog = false
      })
    },
    // 只读角色查看认领申请详情（复用审核弹窗，隐去审核操作区）
    handleDetails(row) {
      this.selectDetail = { ...row }
      this.showCheckDialog = true
    },
    close() {
      this.$nextTick(() => {
        this.showInvoice = false
      })
    },
  }
}
</script>

<style scoped>

</style>
